import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ProposalPage } from './Proposal';
import { QuotationPage } from './Quotation';
import { PageHead } from '../components/ui/chrome';
import { Button } from '../components/ui/Button';
import { useOfferSaves } from '../components/documents/offer-save';
import { useEditGuard } from '../lib/dirty';

export function OfferCopyPage() {
  const location = useLocation();
  const copies = (location.state || {}) as { proposal?: Record<string, unknown> | null; quotation?: Record<string, unknown> | null; create?: 'proposal' | 'quotation' | 'both' };
  const proposal = copies.proposal ?? (copies.create === 'proposal' || copies.create === 'both' ? {} : null);
  const quotation = copies.quotation ?? (copies.create === 'quotation' || copies.create === 'both' ? {} : null);
  const [tab, setTab] = useState(proposal ? 'proposal' : 'quotation');
  const [proposalId, setProposalId] = useState('');
  const saves = useOfferSaves();
  useEditGuard(proposal || quotation ? 'new-offer' : '', JSON.stringify(saves.dirty), saves.saveAll);

  if (!proposal && !quotation) {
    return (
      <PageHead crumbs={[{ label: 'Sales offers', to: '/quotations' }, { label: 'New' }]} back={{ label: 'Back to offers', to: '/quotations' }} title="New offer" subtitle="Choose New offer and pick a quotation, a proposal, or both." />
    );
  }

  return (
    <div>
      <PageHead
        crumbs={[{ label: 'Sales offers', to: '/quotations' }, { label: 'New' }]}
        back={{ label: 'Back to offers', to: '/quotations' }}
        title="New offer"
        subtitle="Not saved yet. Save writes every document on this offer."
        actionsInline
        actions={<Button onClick={() => void saves.saveAll()}>Save</Button>}
      />
      <div className="mb-4 flex gap-1 border-b border-[var(--bo-border)]">
        {proposal ? <button type="button" className={`border-b-2 px-3 py-2 text-sm ${tab === 'proposal' ? 'border-[#895CF6] text-[var(--bo-text)]' : 'border-transparent text-[var(--bo-muted)]'}`} onClick={() => setTab('proposal')}>Proposal</button> : null}
        {quotation ? <button type="button" className={`border-b-2 px-3 py-2 text-sm ${tab === 'quotation' ? 'border-[#895CF6] text-[var(--bo-text)]' : 'border-transparent text-[var(--bo-muted)]'}`} onClick={() => setTab('quotation')}>Quotation</button> : null}
      </div>
      {proposal ? (
        <div className={tab === 'proposal' ? '' : 'hidden'}>
          <ProposalPage bare paired saveAll={saves.saveAll} initial={proposal} onCreated={setProposalId} registerSave={saves.registerProposal} onDirty={saves.onProposalDirty} />
        </div>
      ) : null}
      {quotation ? (
        <div className={tab === 'quotation' ? '' : 'hidden'}>
          <QuotationPage bare paired saveAll={saves.saveAll} initial={quotation} linkedProposalId={proposalId} linkProposalId={saves.linkProposalId} registerSave={saves.registerQuotation} onDirty={saves.onQuotationDirty} />
        </div>
      ) : null}
    </div>
  );
}
